import type { UserRole } from '@/types'

export interface NavigationItem {
  /** i18n key — translate with t(labelKey) in the UI */
  labelKey: string
  icon: string
  route: string
  name: string
}

export interface NavigationSection {
  key: string
  /** i18n key — translate with t(labelKey) in the UI */
  labelKey: string
  items: NavigationItem[]
}

export function getNavigationSections(userRole: UserRole): NavigationSection[] {
  const sections: NavigationSection[] = [
    {
      key: 'user',
      labelKey: 'nav.account',
      items: [
        {
          labelKey: userRole === 'owner' ? 'nav.dashboard' : 'nav.home',
          icon: userRole === 'owner' ? 'pi pi-chart-bar' : 'pi pi-home',
          route: userRole === 'owner' ? '/owner/dashboard' : '/dashboard',
          name: userRole === 'owner' ? 'OwnerDashboard' : 'Dashboard',
        },
        { labelKey: 'nav.challenges', icon: 'pi pi-trophy', route: '/challenges', name: 'Challenges' },
        { labelKey: 'nav.tickets', icon: 'pi pi-ticket', route: '/tickets', name: 'TicketStatus' },
        { labelKey: 'nav.balance', icon: 'pi pi-wallet', route: '/balance', name: 'CashBalance' },
        { labelKey: 'nav.profile', icon: 'pi pi-user', route: '/profile', name: 'Profile' },
        { labelKey: 'nav.notifications', icon: 'pi pi-bell', route: '/notifications', name: 'Notifications' },
        { labelKey: 'nav.privacy', icon: 'pi pi-shield', route: '/privacy', name: 'Privacy' },
        ...(userRole === 'owner'
          ? [{ labelKey: 'nav.approvals', icon: 'pi pi-check-square', route: '/owner/employee-approvals', name: 'EmployeeApprovals' }]
          : []),
      ],
    },
  ]

  return sections
}

export function isNavigationItemActive(currentPath: string, itemRoute: string): boolean {
  return currentPath === itemRoute || currentPath.startsWith(`${itemRoute}/`)
}
